@if (Vendor) {
  <div class="vendor-owners">
    <div class="action-row justify-end vendor-owners__head">
      <button type="button" class="btn btn-outline btn-sm" (click)="addOwner()">
        <i class="bi bi-plus-lg me-1"></i>
        Add owner
      </button>
    </div>

    @if (OwnerFormGroups.length === 0) {
      <p class="vendor-owners__empty">No owners on file yet.</p>
    }

    <div class="vendor-owners__grid">
      @for (OwnerForm of OwnerFormGroups; track OwnerForm; let index = $index) {
        <div class="vendor-owner-card">
          <header class="vendor-owner-card__head">
            <div class="vendor-owner-card__title">
              <h4 class="vendor-owner-card__name">
                {{ OwnerForm.controls['firstName'].value }}
                {{ OwnerForm.controls['lastName'].value }}
              </h4>
            </div>
            <span class="chip chip-info">
              {{ OwnerForm.controls['percentOwner'].value }}% owner
            </span>
          </header>

          <dl class="vendor-owner-card__details">
            <div class="vendor-owner-card__row">
              <dt>Phone</dt>
              <dd>{{ OwnerForm.controls['phone'].value || '—' }}</dd>
            </div>
            <div class="vendor-owner-card__row">
              <dt>DOB</dt>
              <dd>
                {{ (OwnerForm.controls['dob'].value | date: 'MM/dd/y') || '—' }}
              </dd>
            </div>
            <div class="vendor-owner-card__row">
              <dt>State</dt>
              <dd>
                {{
                  OwnerForm.controls['Address'].controls['state'].value || '—'
                }}
              </dd>
            </div>
            @if (OwnerForm.controls['ssn'].value) {
              <div class="vendor-owner-card__row">
                <dt>SSN (1st 5)</dt>
                <dd>{{ OwnerForm.controls['ssn'].value }}</dd>
              </div>
            }
          </dl>

          <div class="vendor-owner-card__actions">
            <button
              type="button"
              class="vendor-owner-card__delete"
              title="Delete owner"
              aria-label="Delete owner"
              (click)="deleteOwner(OwnerForm, index)"
            >
              <i class="bi bi-trash"></i>
            </button>
            <button
              type="button"
              class="btn btn-outline btn-sm vendor-owner-card__edit"
              (click)="editOwner(OwnerForm)"
            >
              <i class="bi bi-pencil me-1"></i>
              Edit
            </button>
          </div>
        </div>
      }
    </div>
  </div>
}
